const HOST = window.location.host;
const isProd = HOST === "admin.sided.co";
const isStage = HOST === "admin.sidedstage.com";

export const API_URL = isProd
  ? "https://api2.sided.co"
  : isStage
    ? "https://api.sidedstage.com"
    : "https://api.sided.dev";

export const NEW_API_URL = isProd
  ? "https://apiv7.sided.co/api"
  : isStage
    ? "https://apiv7.sidedstage.com/api"
    : "https://apiv7.sided.dev/api";

export const REPORTS_API_URL = isProd
  ? "https://apiv7.sided.co/api/reports/v2"
  : isStage
    ? "https://apiv7.sidedstage.com/api/reports/v2"
    : "https://apiv7.sided.dev/api/reports/v2";

export const EXPORT_REPORTS_API_URL = isProd
  ? "https://cron.sided.co/api/reports/v2"
  : isStage
    ? "https://cron.sidedstage.com/api/reports/v2"
    : "https://cron.sided.dev/api/reports/v2";

export const API_V7_URL = isProd
  ? "https://apiv7.sided.co"
  : isStage
    ? "https://apiv7.sidedstage.com"
    : "https://apiv7.sided.dev";

export const ADMIN_WEBSITE_URL = isProd
  ? "https://admin.sided.co"
  : isStage
    ? "https://admin.sidedstage.com"
    : "https://admin.sided.dev";

export const MAIN_WEBSITE_URL = isProd
  ? "https://sided.co"
  : isStage
    ? "https://sidedstage.com"
    : "https://sided.dev";
export const BASENAME = "";
export const USERS_PER_PAGE = 25;
export const DEBATES_PER_PAGE = 25;
export const MODERATION_PER_PAGE = 10;
export const TOP_DEBATES_PER_PAGE = 9999999;
export const SUGGESTED_DEBATES_PER_PAGE = 12;
export const EMBED_PAGES_PER_PAGE = 25;
export const NETWORKS_PER_PAGE = 9999999;
export const DEFAULT_DEBATE_BG_URL =
  "https://cdn.sided.co/prod/sided/users/default-avatar.png";
export const DEFAULT_USER_IMG_URL =
  "https://cdn.sided.co/prod/sided/users/default-avatar.png";
export const DEFAULT_USER_COVER_URL =
  "https://cdn.sided.co/prod/sided/covers/default-cover.png";
export const MAIN_NETWORK_NAME = "sided";
export const SIDED_SUPPORT_EMAIL = "support@sided.co";
export const DEFAULT_DEBATE_DURATION = 7;
export const MAX_DEBATE_DURATION = 180;
export const SIDED_FAVICON =
  "https://cdn.sided.co/prod/sided/wl/sided/images/c7bcd500-0852-11eb-8f00-0f8ed472b657.png";
export const SIDED_LOGO =
  "https://cdn.sided.co/prod/sided/wl/sided/images/c7ac0980-0852-11eb-b673-1dad531e23be.png";
export const SIDES_COLORS = {
  "side-1": "#67bb69",
  "side-2": "#a940bb",
  "side-3": "#43a5f5",
  "side-4": "#ed3f7a",
  "side-5": "#00BCD3",
  "side-6": "#ffbe68",
};
export const FORMAT_DATE_API = "YYYY-MM-DD";
export const GROUP_BY_FILTER_FORMATS = {
  DATE_FULL_MONTH: "MMMM D, YYYY",
  DATE_HALF_MONTH: "MMM D, Y",
  MONTH: "MMM, Y",
  MONTH_YEAR: "MMMM Y",
};

export const PAGE_SIZE = {
  INFINITE_SCROLL: 25,
};
export const YES_NO_OPTIONS = (transFunction) => {
  return [
    { label: transFunction ? transFunction("Yes") : "Yes", value: "1" },
    { label: transFunction ? transFunction("No") : "No", value: "0" },
  ];
};
export const EMAIL_REGEX = /\S+@\S+\.\S+/;

export const SHOW_HIDE_OPTIONS = (transFunction) => {
  return [
    {
      label: transFunction
        ? transFunction("Show everywhere")
        : "Show everywhere",
      value: "0",
    },
    {
      label: transFunction
        ? transFunction("Hide from feeds")
        : "Hide from feeds",
      value: "1",
    },
  ];
};

export const numberOfQuestionsArray = Array.from(
  { length: 20 },
  (_, i) => i + 1,
);

export const questionTimerMapping = {
  Off: 0,
  "5 seconds": 5,
  "10 seconds": 10,
  "15 seconds": 15,
  "20 seconds": 20,
  "30 seconds": 30,
};
export const SUBSCTYPE_STANDARD = 1;
export const SUBSCTYPE_PRO = 2;
export const SUBSCTYPE_BUSINESS = 3;
export const SUBSCTYPE_ENTERPRISE = 4;
export const SUBSCTYPE_FREE = 5;